export default {
  getAllAssetComponents: state => state.assetComponents || [],
};
